module.exports = __webpack_public_path__ + "img/app_food_text.fa7b941e.png";